<template>
  <div>
    <v-form v-model="isFormValid" ref="form">
      <!-- Customer -->
      <AdminFieldRelated
        :item="cart"
        label="Customer"
        :Model="CartModel"
        :header="{
          value: 'customer.full_name',
          foreignModel: CustomerModel,
        }"
        @update="setCustomer"
        :rules="[ValidationRules.required]"
      />

      <!-- Availability -->
      <AdminFieldRelated
        :item="cart"
        :Model="CartModel"
        :header="{
          value: 'availability.name',
          foreignModel: AvailabilityModel,
        }"
        sort-key="start_time"
        label="Availability"
        @update="$emit('update', $event)"
        :rules="[ValidationRules.required]"
      />

      <!-- Fulfillment Type -->
      <AdminFieldSingleSelect
        :value="cart.fulfillment_type"
        :Model="CartModel"
        :items="getFulfillmentOptions"
        :id="cart.id"
        label="Fulfillment Type"
        field-name="fulfillment_type"
        no-data-text="Please select at least one Fulfillment Option in your Shop Settings"
        @change="$emit('update', { fulfillment_type: $event })"
        invalid-tooltip="Please choose valid Fulfillment Type"
      />

      <!-- Fulfillment Slot -->
      <AdminFieldFulfillmentSlotPicker
        :fulfillment-type="cart.fulfillment_type"
        :availability="cart.availability"
        :value="cart.fulfillment_slot"
        field-name="fulfillment_slot"
        label="Fulfillment Slot"
        @change="$emit('update', { fulfillment_slot: $event })"
      />

      <!-- Delivery Address -->
      <v-text-field
        v-if="cart.fulfillment_type === 'Delivery'"
        label="Delivery Address"
        :value="cart.delivery_address"
        @change="$emit('update', { delivery_address: $event })"
        :rules="[ValidationRules.requiredString]"
        v-bind="globalFieldAttrs"
      />
      <!-- Special Instructions -->
      <AdminFieldTextarea
        label="Order Notes"
        :value="cart.special_instructions"
        @change="$emit('update', { special_instructions: $event })"
        v-bind="globalFieldAttrs"
      />

      <!-- Completed -->
      <AdminFieldCheckbox
        :Model="CartModel"
        :id="cart.id"
        label="Completed"
        size="x-large"
        field-name="completed"
        @click="$emit('update', { completed: !cart.completed })"
        v-bind="globalFieldAttrs"
      />

      <!-- Paid -->
      <AdminFieldCheckbox
        :Model="CartModel"
        :id="cart.id"
        label="Paid"
        size="x-large"
        field-name="paid"
        @click="$emit('update', { paid: !cart.paid })"
        v-bind="globalFieldAttrs"
      />

      <!-- Ready For Guest -->
      <AdminFieldCheckbox
        :Model="CartModel"
        :id="cart.id"
        label="Ready For Guest"
        size="x-large"
        field-name="ready_for_guest"
        @click="$emit('update', { ready_for_guest: !cart.ready_for_guest })"
        v-bind="globalFieldAttrs"
      />

      <h3>Order Items</h3>
      <AdminNewOrderBuilder :customer-id="customerId" :cart="cart" />
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ValidationRules from '@/constants/ValidationRules'

import CartModel from '@/models/CartModel'
import CustomerModel from '@/models/CustomerModel'
import AvailabilityModel from '@/models/AvailabilityModel'

import _get from 'lodash/get'

import AdminFieldCheckbox from '@/components/AdminFieldCheckbox'
import AdminFieldRelated from '@/components/AdminFieldRelated'
import AdminFieldSingleSelect from '@/components/AdminFieldSingleSelect'
import AdminFieldTextarea from '@/components/AdminFieldTextarea'
import AdminFieldFulfillmentSlotPicker from '@/components/AdminFieldFulfillmentSlotPicker'
import AdminNewOrderBuilder from '@/components/AdminNewOrderBuilder'
export default {
  name: 'AdminNewOrderForm',
  components: {
    AdminFieldCheckbox,
    AdminFieldRelated,
    AdminFieldSingleSelect,
    AdminFieldTextarea,
    AdminFieldFulfillmentSlotPicker,
    AdminNewOrderBuilder,
  },
  props: {
    cart: {
      type: CartModel,
      require: true,
      default: () => new CartModel(),
    },
  },
  data() {
    return {
      isFormValid: false,
      customerId: null,
      cartId: null,
      CustomerModel,
      CartModel,
      AvailabilityModel,
      ValidationRules,
    }
  },
  methods: {
    setCustomer($event) {
      this.$emit('update', $event)
      this.customerId = $event.user_id
    }, // setCustomer

    _get,
  },
  async mounted() {
    this.$refs.form.validate()
  },
  computed: {
    ...mapGetters('shop', ['getFulfillmentOptions']),
    globalFieldAttrs() {
      const defaults = { outlined: true, dense: true }
      return { ...defaults }
    },
  },
  watch: {
    async ['cart.isValid'](cartValidity) {
      await this.$refs.form.validate()
      let areFormAndCartValid = cartValidity && this.isFormValid

      this.$emit('form:valid', areFormAndCartValid)
    },
    async isFormValid(isFormValid) {
      await this.$refs.form.validate()
      let areFormAndCartValid = this.cart.isValid && isFormValid

      this.$emit('form:valid', areFormAndCartValid)
    },
  },
}
</script>
